import {
  initialState,
  Actions,
  State,
  NEW_CATEGORY,
  NEW_CATEGORY_SUCCESS,
  NEW_CATEGORY_ERROR,
  RESET_NEW_CATEGORY,
} from "../../types/category/new-category";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_CATEGORY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_CATEGORY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_CATEGORY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_CATEGORY:
      return initialState
    default:
      return state;
  }
};

export default reducers;
